import $ from 'jquery';

$(document)
  .on('click touchstart', '#help-forgot', (e) => {
    $('#signin-login').animate({ opacity: 0 }, 300, function () {
      $(this).toggle(false).css('opacity', 1);
    });

    $('#signin-forgot').animate({ opacity: 0 }, 300, function () {
      $(this).toggle(true).css('opacity', 1);
    });

    e.preventDefault();
  })
  .on('click touchstart', '#help-back', (e) => {
    $('#signin-login').animate({ opacity: 0 }, 300, function () {
      $(this).toggle(true).css('opacity', 1);
    });

    $('#signin-forgot').animate({ opacity: 0 }, 300, function () {
      $(this).toggle(false).css('opacity', 1);
    });

    e.preventDefault();
  });